
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useUserRoles } from '@/hooks/useUserRoles';
import { useIsMobile } from '@/hooks/use-mobile';
import { Home, Calendar, Settings, Users, Target, Heart } from 'lucide-react';
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarTrigger,
} from '@/components/ui/sidebar';

const AppSidebar: React.FC = () => {
  const { user } = useAuth();
  const { currentUserRole } = useUserRoles();
  const location = useLocation();
  const isMobile = useIsMobile();

  const navItems = [
    {
      path: '/',
      label: 'Dashboard',
      icon: Home,
    },
    {
      path: '/contacts',
      label: 'Contacts',
      icon: Users,
    },
    {
      path: '/campaigns',
      label: 'Campaigns',
      icon: Target,
    },
    {
      path: '/events',
      label: 'Events',
      icon: Calendar,
    },
    {
      path: '/gifts',
      label: 'Gifts',
      icon: Heart,
    },
  ];

  // Add admin link if user is admin
  if (currentUserRole === 'admin') {
    navItems.push({
      path: '/admin',
      label: 'Admin',
      icon: Settings,
    });
  }

  return (
    <Sidebar collapsible="icon">
      <SidebarContent className="mt-20 mx-0">
        {/* Only show trigger on desktop */}
        {!isMobile && (
          <div className="flex items-center justify-between pt-[10px] px-2 m-0">
            <SidebarGroupLabel className="group-data-[collapsible=icon]:hidden">Navigation</SidebarGroupLabel>
            <SidebarTrigger className="h-9 w-9" />
          </div>
        )}
        
        {/* Show group label on mobile without trigger */}
        {isMobile && (
          <div className="p-2 py-0 my-0">
            <SidebarGroupLabel className="group-data-[collapsible=icon]:hidden">Navigation</SidebarGroupLabel>
          </div>
        )}

        <SidebarGroup className="">
          <SidebarGroupContent>
            <SidebarMenu>
              {navItems.map(({ path, label, icon: Icon }) => (
                <SidebarMenuItem key={path}>
                  <SidebarMenuButton asChild isActive={location.pathname === path} tooltip={label}>
                    <Link to={path}>
                      <Icon className="h-5 w-5" />
                      <span>{label}</span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
};

export default AppSidebar;
